/**
 * Hier kommt übergreifender Code für folgende Mitarbeiterstammdaten hin
 * - Personalien
 * - Beschaeftigung
 * - Abgaben
 * - Lohnarten & Nettobezüge
 * - Zuschläge
 * - Historie
 */

import _ from 'underscore';
import dayjs from '../../../../shared/services/dayjs.js';
import stammdatenService from '../services/stammdatenService.js';
import {
    debounce,
    erstelleMitarbeiterListe,
    resetValidationMessages,
} from '../util.js';
import basedataService from '../services/basedataService.js';

const debounceSpeichereMA = debounce(async (args) => {
    const maToSave = args[0];
    // Validierung: speichere nur, wenn es noch der gleiche MA ist (verhindert Race Conditions bei schnellem Wechsel)
    if (maToSave._id !== stammdatenService.aktuellerMitarbeiter._id) {
        return;
    }
    checkElterneigenschaft(stammdatenService.aktuellerMitarbeiter);
    await stammdatenService.updateMitarbeiterdaten(maToSave);
    // validierung entsprechend des Mitarbeiter Reiters
    switch (window.myVars.websiteStatus) {
        case 'ma-personalien':
            validatePersonalien(stammdatenService.aktuellerMitarbeiter);
            break;
        case 'ma-beschaeftigung':
            validateBeschaeftigung(stammdatenService.aktuellerMitarbeiter);
            break;
        case 'ma-zuschlaege':
            validateZuschlaege(stammdatenService.aktuellerMitarbeiter);
            break;
        case 'ma-abgaben':
            validateAbgaben(stammdatenService.aktuellerMitarbeiter);
            break;
        case 'ma-zeitkonto':
            validateZeitkonto(stammdatenService.aktuellerMitarbeiter);
            break;
        default:
            break;
    }
    await erstelleMitarbeiterListe(stammdatenService.aktuelleBetriebsstaette);
}, 1000);

/**
 * Speichert die aktuellen Mitarbeiterdaten, falls es eine Änderung gibt.
 */
async function forceUpdateMA() {
	// Falls es Änderungen im Mitarbeiter Objekt gibt, müssen wir erst speichern und den debounce entfernen...
	if (window.myVars.mitarbeiterEditiert && !_.isEmpty(stammdatenService.aktuellerMitarbeiter)) {
		await stammdatenService.updateMitarbeiterdaten(stammdatenService.aktuellerMitarbeiter);
		clearTimeout(window.myVars.lastDebounceId);
	}
}

function validateZeitkonto(aktuellerMA) {
    resetValidationMessages();
    const htmlParent = document.getElementById('ma-Zeitkonto');
    const validateResults = aktuellerMA.Errors;
    validateResults.forEach((error) => {
        const htmlElement = htmlParent.querySelector(`[aria-label="${error.instancePath}"]`);
        if (htmlElement) {
            htmlElement.innerText = error.message;
        }
    });
}

function validateAbgaben(aktuellerMA) {
    resetValidationMessages();
    const htmlParent = document.getElementById('ma-Abgaben');
    const validateResults = aktuellerMA.Errors;
    validateResults.forEach((error) => {
        const htmlElement = htmlParent.querySelector(`[aria-label="${error.instancePath}"]`);
        if (htmlElement) {
            htmlElement.innerText += error.message + '\n';
        }
    });
    const besch = aktuellerMA.Beschaeftigung[0];
    htmlParent.querySelector('#empty-rvNr').style.display = besch.Sozialversicherung.Rentenversicherungsnummer === '' ? 'flex' : 'none';
    htmlParent.querySelector('#empty-steuerID').style.display = besch.Steuer.SteuerIdentifikationsnummer === '' ? 'flex' : 'none';
}


function validatePersonalien(aktuellerMA) {
    const htmlDiv = document.getElementById('ma-Personalien');
    resetValidationMessages();
    const validateResults = aktuellerMA.Errors;
    validateResults.forEach((error) => {
        const htmlElement = htmlDiv.querySelector(`[aria-label="${error.instancePath}"]`);
        if (htmlElement) {
            htmlElement.innerText = error.message;
        }
    });
    htmlDiv.querySelector('#empty-geburtsort').style.display = aktuellerMA.Personalien.Geburtsort === '' ? 'flex' : 'none';
}

function validateBeschaeftigung(aktuellerMA) {
    resetValidationMessages();
    const htmlParent = document.getElementById('ma-Beschaeftigung');
    const validateResults = aktuellerMA.Errors;
    validateResults.forEach((error) => {
        // Für die Regelarbeitszeiten müssen wir 2x7 messages zeigen...
        if (error?.instancePath?.includes('Regelarbeitszeiten')) {
            const htmlElement = htmlParent.querySelector('[aria-label="/Beschaeftigung/0/Regelarbeitszeiten"]');
            htmlElement.innerText = error.message;
            return;
        }
        // Chef vom Dienst braucht hier keine Fehlermeldung
        if (error?.instancePath?.includes('Verguetung/') && !window.myVars.HideMod) {
            const htmlElement = htmlParent.querySelector(`[aria-label="/Beschaeftigung/0/Verguetung/__index__/${error.instancePath.split('/')[5]}"]`);
            if (htmlElement) {
                htmlElement.innerText = error.message;
                return;
            }
        }
        const htmlElement = htmlParent.querySelector(`[aria-label="${error.instancePath}"]`);
        if (error.message.includes('Qualifikation nicht vorhanden')) {
            htmlElement.innerHTML = `
            ${error.message}&nbsp;
            <a href="https://handbuch.neolohn.de/link/355#bkmrk-2.-%E2%80%9Equalifikation-ni" target="_blank" title="Öffne Hilfe im Handbuch">
                <i class="bi bi-info-circle"></i>
            </a>`;
            return;
        }
        if (htmlElement) {
            htmlElement.innerText = error.message;
        }
    });
}

function validateZuschlaege(aktuellerMA) {
    const htmlDiv = document.getElementById('ma-Zuschlaege');
    resetValidationMessages();
    const validateResults = aktuellerMA.Errors;
    validateResults.forEach((error) => {
        const htmlElement = htmlDiv.querySelector(`[aria-label="${error.instancePath}"]`);
        if (htmlElement) {
            htmlElement.innerText = error.message;
        }
    });
}

function checkElterneigenschaft(mitarbeiter) {
    // automatisch aktiv, falls MA Kinder hat oder Kinderfreibetrag
    const maHatKinder = mitarbeiter.Beschaeftigung[0].Sozialversicherung.AnzahlKinder > 0 || mitarbeiter.Beschaeftigung[0].Steuer.Kinderfreibetrag > 0 || mitarbeiter.Beschaeftigung[0].Sozialversicherung.GeburtstageKinder.length > 0;
    // Elterneigenschaft automatisch auf true setzen falls Kinder vorhanden, aber nicht automatisch auf false
    if (maHatKinder) {
        mitarbeiter.Beschaeftigung[0].Sozialversicherung.Elterneigenschaft = maHatKinder;
    }
    // Wenn MA Kinder hat bzw Elterneigenschaft aktiv oder jünger als 23 ist, dann zahlt er keinen PV Zusatz
    // ohne Geburtsdatum kann das Alter nicht bestimmt werden, dann bleibt der gespeicherte Wert unverändert
    const geburtsdatum = mitarbeiter.Personalien.Geburtsdatum ? dayjs.tz(mitarbeiter.Personalien.Geburtsdatum, dayjs.tz.DEFAULT_TZ) : null;
    if (geburtsdatum?.isValid()) {
        const zeitraum = window.myVars.aktuellesMonatsDatum;
        const mitarbeiterAlter = zeitraum.diff(geburtsdatum, 'year');
        // ... umgekehrt heißt dass, wenn der Mitarbeiter keine Elterneigenschaft und 23 oder älter ist, dann zahlt er den PV Zusatz
        mitarbeiter.Beschaeftigung[0].Sozialversicherung.PflegeversicherungsZusatz = !mitarbeiter.Beschaeftigung[0].Sozialversicherung.Elterneigenschaft && mitarbeiterAlter >= 23;
    }
    const elternCheck = document.body.querySelector('[aria-label="ma-Elterneigenschaft"]');
    if (elternCheck) {
        elternCheck.checked = mitarbeiter.Beschaeftigung[0].Sozialversicherung.Elterneigenschaft;
    }
    const pvZusatzCheck = document.body.querySelector('[aria-label="ma-PflegeversicherungsZusatz"]');
    if (pvZusatzCheck) {
        pvZusatzCheck.checked = mitarbeiter.Beschaeftigung[0].Sozialversicherung.PflegeversicherungsZusatz;
    }
}

/**
 * Zeigt Fristen an und wie viele Tage noch fehlen. 
 * 
 * Hier kann die Zeitzone außer Betracht gezogen werden, da wir nur Differenzen vergleichen.
 * 
 * @param {*} neochecker 
 * @param {*} mitarbeiter 
 * @returns 
 */
async function neocheckerMitarbeiterFristen(neochecker, mitarbeiter) {
    if (!neochecker || !mitarbeiter) return;
    const heute = dayjs().startOf('day');
    // kein Check wenn MA schon ausgetreten ist.
    const austrittMA = mitarbeiter.Beschaeftigung[0].Austrittsdatum ? dayjs(mitarbeiter.Beschaeftigung[0].Austrittsdatum) : '';
    if (austrittMA && heute.isAfter(austrittMA)) return;
    // Check Aufenthalt + Arbeitsgenehmigung
    if (mitarbeiter.Personalien.Staatsangehoerigkeit.Nationenschluessel) {
        const laender = await basedataService.holeLaenderBasedataProvider();
        const euLaender = laender.filter((land) => land.EgMitglied == '1');
        const isEUMitglied = euLaender.some((land) => land.Nationenschluessel == mitarbeiter.Personalien.Staatsangehoerigkeit.Nationenschluessel);
        if (!isEUMitglied) {
            const aufenthaltFrist = dayjs(mitarbeiter.Beschaeftigung[0].AufenthaltsgenehmigungBis); 
            const arbeitserlaubnisFrist = dayjs(mitarbeiter.Beschaeftigung[0].ArbeitserlaubnisBis); 
            // Wenn keine First eingegeben -99999, sonst die Differenz zum heutigen Tag...
            const aufenthaltDiff = aufenthaltFrist.isValid() ? heute.diff(aufenthaltFrist, 'days') * -1 : -99999999;
            const arbeitserlaubnisDiff = arbeitserlaubnisFrist.isValid() ? heute.diff(arbeitserlaubnisFrist, 'days') * -1 : -99999999;
            const aufenthaltNachAustritt = aufenthaltFrist.isValid() && austrittMA ? aufenthaltFrist.isSameOrAfter(austrittMA) : false;
            const arbeitserlaubnisNachAustritt = arbeitserlaubnisFrist.isValid() && austrittMA ? arbeitserlaubnisFrist.isSameOrAfter(austrittMA) : false;
            if (!aufenthaltNachAustritt && aufenthaltDiff < 0) {
                neochecker.showMessage('Aufenthaltsgenehmigung abgelaufen / fehlt!', 'error');
            }
            if (!arbeitserlaubnisNachAustritt && arbeitserlaubnisDiff < 0) {
                neochecker.showMessage('Arbeitserlaubnis abgelaufen / fehlt!', 'error');
            }
            if (!aufenthaltNachAustritt && aufenthaltDiff >= 0 && aufenthaltDiff <= 90) {
                neochecker.showMessage(`Aufenthaltsgenehmigung läuft in ${aufenthaltDiff} Tagen aus!`, 'warning');
            }
            if (!arbeitserlaubnisNachAustritt && arbeitserlaubnisDiff >= 0 && arbeitserlaubnisDiff <= 90) {
                neochecker.showMessage(`Arbeitserlaubnis läuft in ${arbeitserlaubnisDiff} Tagen aus!`, 'warning');
            }
        }
    }
    // Check Student Immatrikulationsbescheinigung
    if (mitarbeiter.Beschaeftigung[0].Personengruppenschluessel == '106') {
        const immatrikulationFrist = dayjs(mitarbeiter.Beschaeftigung[0].Immatrikulationsbescheinigung);
        // Wenn keine First eingegeben -99999, sonst die Differenz zum heutigen Tag...
        const immatrikulationDiff = immatrikulationFrist.isValid() ? heute.diff(immatrikulationFrist, 'days') * -1 : -99999999;
        const immatrikulationNachAustritt = immatrikulationFrist.isValid() && austrittMA ? immatrikulationFrist.isSameOrAfter(austrittMA) : false;
        if (!immatrikulationNachAustritt && immatrikulationDiff < 0) {
            neochecker.showMessage('Immatrikulationsbescheinigung abgelaufen / fehlt!', 'error');
        }
        if (!immatrikulationNachAustritt && immatrikulationDiff >= 0 && immatrikulationDiff <= 90) {
            neochecker.showMessage(`Immatrikulationsbescheinigung läuft in ${immatrikulationDiff} Tagen aus!`, 'warning');
        }
    }
    
}

export {
    forceUpdateMA,
    debounceSpeichereMA,
    validatePersonalien,
    validateBeschaeftigung,
    validateZeitkonto,
    validateAbgaben,
    validateZuschlaege,
    neocheckerMitarbeiterFristen
};
